import {Pipe, PipeTransform} from "@angular/core";
import {LEGAL_ENTITY_TYPES} from "../_maps/legal-entity-types";

@Pipe({name: "legalEntityType"})
export class LegalEntityTypePipe implements PipeTransform {
  transform(type: string): string {
    return type && LEGAL_ENTITY_TYPES[type] || '';
  }
}
